import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import { alpha } from '@material-ui/core/styles';

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20];

export function MaterialTablePaginationMui412(props) {
  const { rowsPerPageOptions, ...rest } = props;

  return (
    <TablePagination
      {...rest}
      rowsPerPageOptions={
        Array.isArray(rowsPerPageOptions) && rowsPerPageOptions.length
          ? rowsPerPageOptions
          : DEFAULT_ROWS_PER_PAGE_OPTIONS
      }
      onPageChange={rest.onPageChange || rest.onChangePage}
      onRowsPerPageChange={rest.onRowsPerPageChange || rest.onChangeRowsPerPage}
    />
  );
}

export function MaterialTableOverlayLoadingMui412({ theme }) {
  return (
    <div
      style={{
        display: 'table',
        width: '100%',
        height: '100%',
        backgroundColor: alpha(theme.palette.background.paper, 0.7),
      }}
    >
      <div
        style={{
          display: 'table-cell',
          width: '100%',
          height: '100%',
          verticalAlign: 'middle',
          textAlign: 'center',
        }}
      >
        <CircularProgress />
      </div>
    </div>
  );
}

export const materialTableMui412CompatComponents = {
  Pagination: MaterialTablePaginationMui412,
  OverlayLoading: MaterialTableOverlayLoadingMui412,
};
